import Image from "next/image";
import Card from "@/components/UI/Card/Card";
import Link from "@/components/UI/Link/Link";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";

interface Section09Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const MentionsSection = ({ job, page, section, ...props }: Section09Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer section={section}>
        <SectionHeader section={section} />
        {section?.Cards?.length > 0 && (
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
            {section?.Cards?.map((item: any) => {
              return (
                <Card className="flex flex-col gap-4 rounded-md p-6" key={item?.id}>
                  <div className="flex justify-between">
                    {item?.Image?.data?.attributes && (
                      <Image
                        alt={item?.Image?.data?.attributes?.alternativeText}
                        className="w-20"
                        src={item?.Image?.data?.attributes?.url}
                        height={item?.Image?.data?.attributes?.height ?? "100"}
                        width={item?.Image?.data?.attributes?.width ?? "100"}
                      />
                    )}
                    <div className="text-vpGray-700">{item?.Dateline}</div>
                  </div>
                  <div className="text-lg text-vpGray-700">{item?.Caption}</div>
                  {item?.LinkUrl && item?.LinkLabel && (
                    <Link className="mt-2" href={item?.LinkUrl} variant="external">
                      {item?.LinkLabel}
                    </Link>
                  )}
                </Card>
              );
            })}
          </div>
        )}
      </SectionContainer>
    </Section>
  );
};

export default MentionsSection;
